import { classnames } from '@/utils/classnames/classnames';
import { cva } from '@/utils/classnames/cva';
import { asClassStyle } from '@/components/utils/helpers/variants';
import { CheckboxProps } from '../../types';

const useClassNames = ({
  checked,
  size,
  disabled,
  containerClassName,
}: Pick<CheckboxProps, 'checked' | 'size' | 'disabled' | 'containerClassName'>) => {
  const checkedVariant = checked ? 'checked' : 'unChecked';
  const disabledVariant = disabled ? 'disabled' : 'active';

  const resolveCheckboxVariant = cva({
    intent: {
      active: {
        checked:
          'cursor-pointer border-primary bg-primary checked:border-primary checked:bg-primary checked:hover:border-primary checked:hover:bg-primary checked:focus:border-primary checked:focus:bg-primary',
        unChecked: 'cursor-pointer border-secondary bg-white-100 hover:border-primary',
      },
      disabled: {
        checked:
          'cursor-not-allowed border-secondary bg-secondary checked:border-secondary checked:bg-secondary checked:hover:border-secondary checked:hover:bg-secondary checked:focus:border-secondary checked:focus:bg-secondary',
        unChecked: 'cursor-not-allowed border-neutral-400 bg-white-100',
      },
    },
    size: {
      lg: 'h-[20px] w-[20px]',
      sm: 'h-[16px] w-[16px]',
    },
  });

  const checkboxClassName = classnames(
    'rounded-sm border focus:shadow-dark focus:ring-transparent focus:ring-offset-0',
    asClassStyle('b2') as string,
    resolveCheckboxVariant(`intent.${disabledVariant}.${checkedVariant}`) as string,
    resolveCheckboxVariant(`size.${size}`) as string,
  );

  const resolveLabelVariant = cva({
    intent: {
      active: { checked: 'text-primary', unChecked: 'text-primary' },
      disabled: {
        checked: 'text-secondary',
        unChecked: 'text-neutral-400',
      },
    },
  });

  const labelClassName = classnames(
    asClassStyle('b2') as string,
    resolveLabelVariant(`intent.${disabledVariant}.${checkedVariant}`) as string,
  );

  const containerClassNames = classnames('flex w-fit items-center gap-2', containerClassName);

  return { checkboxClassName, labelClassName, containerClassNames };
};

export default useClassNames;
